





















































































	import {Prop, Watch} from "vue-property-decorator";
	import {Stored} from 'vue-stored-prop-decorator';
	import {Component, Vue} from '@/shared/component';
	import {Timeout, WatchObjectProperties} from '@/shared/decorator';

	import {storeVentesTotaux, VenteFilter} from '@/stores/modules/vente';

	import InputDateFilter from '@/components/Input/DateFilter.vue';
	import CrudClientSearch from "@/components/Crud/Client/Search.vue";
	import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
	import InputBoisType from "@/components/Input/BoisType.vue";
	import InputLongueursVente from "@/components/Input/LongueursVente.vue";
	import {DateFilterMode} from "@/shared/filter";

	@Component({
		components: {
			InputDateFilter,
			CrudClientSearch,
			InputBoisType,
			InputLongueursVente,
			CrudTransporteurSearch,
		}
	})
	export default class CrudVenteFilterTotauxVentes extends Vue {

		@Prop({ type: Boolean, default: false}) reduce!: boolean;

		@Stored(() => storeVentesTotaux) private page!: number;
		@Stored(() => storeVentesTotaux) private filters!: VenteFilter;

		@WatchObjectProperties('filters', VenteFilter)
		@Timeout()
		private filtersWatcher(): void {
			this.page = 0;
			storeVentesTotaux.dispatch( 'getTotauxVentes', { filters: true });
		}
		
		public mounted() {
		    this.typeWatcher();
			let dt = new Date();
			let firstDayYear = new Date(new Date().getFullYear(), 0, 2);
			dt.setDate(dt.getDate() - 90);
			this.filters.totalDateDebut = firstDayYear.toISOString().slice(0, 10)
			this.filters.totalDateFin = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
			this.filters.totalParClient = true;
			this.filters.totalParBoisType = true;
			this.filters.totalParLongueur = true;
		}

		get computedDateStartFormatted () : string {
        	return this.formatDate(this.filters.totalDateDebut)
      	}

		get computedDateEndFormatted () : string {
        	return this.formatDate(this.filters.totalDateFin)
      	}

		  formatDate (date) {
        		if (!date) return null

        	const [year, month, day] = date.split('-')
        	return `${day}/${month}/${year}`
      	}

	    @Watch('type')
		private typeWatcher(): void {
            this.filters.clear();

		}

		private get methodName(): string {
			return 'getTotauxVentes';
		}

		@Watch('order')
		@Watch('page')
		@Watch('direction')
		private refresh(): void {
			storeVentesTotaux.dispatch(this.methodName, { filters: true });
		}

		private menu = false;
		private menuEnd = false;
	}
